export default "__VITE_ASSET__f5846460__"